import { Component, Inject, Input, AfterViewInit} from 'ng-metadata/core';
import { QuickLink } from './quickLink.service';
import { PrimoResponse } from '../../infra/dataStructures/PrimoResponses/doc.interfcae';
import { getBackendSystem } from '../../appConfig/appConfigForward';
import { beacon, PrimolyticsService } from "../../analytics/primolytics.service";
import {StringUtils} from "../../nddUtils/stringUtils.service";
import {AnalyticsUtils} from "../../nddUtils/analyticsUtils.service";


const get = require('lodash/get');

@Component({
    selector: 'prm-quick-link',
    templateUrl: 'components/search/quickLink/quick-link.html'
})

export class PrmQuickLink {

   private _recordLinks: any;
    public iconType: any;
    public iconsToHideInSections: any;
    @Input() public item: PrimoResponse.IDoc;
    @Input() private displaySection: string;
    @Input() isFullDisplay: boolean;//true in full display and false in brief result page 


    constructor(@Inject('availabilityLineIcons') private availabilityLineIcons: Object[],
        private linksService: QuickLink,
        private primolyticsService: PrimolyticsService,
        private stringUtils: StringUtils,
        private analyticsUtils: AnalyticsUtils,
        @Inject('$scope') private $scope: ng.IScope,
        @Inject('$element') private $element: ng.IRootElementService,
        @Inject('$translate') private $translate: ng.translate.ITranslateService,
        @Inject('$timeout') private $timeout: ng.ITimeoutService) {
        this.iconType = {
            PDF: "pdf-link",
            HTML: "html-link"
        };

        this.iconsToHideInSections = {
            Links: true
        };
    }

    ngOnInit() {
        this.recordLinks = [];
        this.updateQuickLink();
        this.showNoLinksErrorlabel = true
    }

    ngAfterViewInit() {
        this.$timeout(() => {
            this.removeRollButton();
        }, 0);
    }

    get recordLinks() {
        return this._recordLinks;
    }

    set recordLinks(arr) {
        this._recordLinks = arr;
    }

    set showNoLinksErrorlabel(value: boolean) {
        this.linksService.showNoLinksErrorlabel = value;
    }

    get showNoLinksErrorlabel() {
        return this.linksService.showNoLinksErrorlabel;
    }

    private isToDisplayIcons() {
        return this.iconsToHideInSections[this.displaySection] ? false : true;
    }

    private iconByType(link) {
        if (link.type) {
            return this.iconType[link.type];
        }
        return '';
    }

    public hasQuickLink() {
        return this.linksService.isQuickLinksAvailable(this.item) || this.linksService.unpaywallEnabled;
    }

    public getQuickLinks() {

        let unpaywallLinks = this.linksService.unpaywallLinks;
        // Use quickLink if exists
        if (this.recordLinks.length != 0) {
            if (this.isFullDisplay) {
                 this.showNoLinksErrorlabel = false;
            }
            return this.recordLinks;
        }


        // Use Unpaywall if exists (in case QuickLink not exists)
        if (unpaywallLinks) {

            let recordid = this.item.pnx.control.recordid;
            if (unpaywallLinks[recordid] != undefined) {
                if (unpaywallLinks[recordid].length) {
                    if (this.isFullDisplay) {
                        if (this.showNoLinksErrorlabel) {
                            this.showNoLinksErrorlabel = false;
                        }
                    }
                }
             }
            if (angular.isArray(recordid)) {
                recordid = recordid[0];
            }
            if (unpaywallLinks[recordid]) {
                return unpaywallLinks[recordid];
            } else if (get(this.item, 'pnx.links.linktopdf[0]', false)) {
                unpaywallLinks[recordid] = this.linksService.getQuickLinksFromPnx(this.item);
                return unpaywallLinks[recordid];
            }
        }
    }

    updateQuickLink() {
        if (this.linksService.isQuickLinksAvailable(this.item)) {
            this.linksService.calculatetQuickLinks(this.item).then((linksToReturn: any) => {
                this.recordLinks = linksToReturn;
            });
        }
    }


    public runQuickLinks(link) {
        if (link.sourceType === "unpaywall") {
            this.reportBeaconUnpaywallPDF();
            this.sendAnalytics("Unpaywall PDF", "Get PDF");
        } else {
            if (link.type === "PDF") {
                this.reportBeaconQuickLinkPDF(link);
                this.sendAnalytics("Quicklinks PDF", "Get PDF");
            }
            if (link.type === "HTML") {
                this.reportBeaconQuickLinkHTML(link);
                this.sendAnalytics("Quicklinks HTML", "Read Online");
            }
        }
    }

    private removeRollButton() {
        let elem = this.$element[0];
        if (elem) {
            elem.removeAttribute('role');
        }
    }

    @beacon({ 'p': 'linksService', 'op': 'QuicklinkPDF' })
    public reportBeaconQuickLinkPDF(item) {
    }

    @beacon({ 'p': 'linksService', 'op': 'QuicklinkHTML' })
    public reportBeaconQuickLinkHTML(item) {
    }

    @beacon({ 'p': 'linksService', 'op': 'UnpaywallPDF' })
    public reportBeaconUnpaywallPDF() {
    }

    private getLinkAriaLabel(link) {
        if(!this.$translate.isReady()) {
            return undefined;
        }
        return this.stringUtils.decode(
            this.$translate.instant(link.ariaLabel, {title: this.item.pnx.display['title'][0]})
        )
    }

    private sendAnalytics(linkType, linkLabel) {
        let payload = this.getAnalyticsPayload(linkType,linkLabel);
        this.analyticsUtils.trackUsage(this.analyticsUtils.eventsNames.ONLINE_RESOURCE_LINK, payload);
    }

    private getAnalyticsPayload(linkType,linkLabel) {
        return {
            'Online Resource Link Type': linkType,
            'Displayed Link Name': linkLabel,
            "Record ID": get(this.item, 'pnx.control.recordid[0]'),
            "Record Title": get(this.item, 'pnx.display.title[0]'),
            "Resource Type": get(this.item, 'pnx.display.type[0]')
        }
    }

}



// WEBPACK FOOTER //
// ./src/main/webapp/components/search/quickLink/quickLink.directive.ts